import { __assign } from "tslib";
export default withDraggableOrder;
function mapOrderFromControllerDataAndOrderlist(list, controller) {
    var sections = controller.options.filter(function (i) { return i.type === 'section'; });
    var result = sections.reduce(function (acc, curr) {
        var _a;
        return __assign(__assign({}, acc), (_a = {}, _a[curr.key] = [], _a));
    }, {});
    var currentSection = sections[0];
    var splited = list.split(',');
    var _loop_1 = function (item) {
        var currentSectionIndex = sections.findIndex(function (x) { return x.key === item; });
        if (currentSectionIndex !== -1) {
            currentSection = sections[currentSectionIndex];
            return "continue";
        }
        else {
            result[currentSection.key].push(item);
        }
    };
    // for (let i = 0; i <splited.length; i++) {
    for (var _i = 0, splited_1 = splited; _i < splited_1.length; _i++) {
        var item = splited_1[_i];
        _loop_1(item);
    }
    return result;
}
function withDraggableOrder(controller, mapper) {
    return function (value) {
        var order = mapOrderFromControllerDataAndOrderlist(value, controller);
        return mapper(order);
    };
}
//# sourceMappingURL=withDraggableOrder.js.map